import { Routes, Route } from 'react-router-dom';
import Layout from '@components/Layout/Layout';
import Home from '@pages/Home';
import About from '@pages/About';
import ArchitecturalWork from '@pages/ArchitecturalWork';
import InteriorWork from '@pages/InteriorWork';
import Contact from '@pages/Contact';
import VR from '@pages/VR';
import Panorama360 from '@pages/Panorama360';
import SketchPad from '@pages/SketchPad';
import VisualizationVsReality from '@pages/VisualizationVsReality';
import ProjectDetail from '@pages/ProjectDetail';
import NotFound from '@pages/NotFound';

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/architectural-work" element={<ArchitecturalWork />} />
                <Route path="/interior-work" element={<InteriorWork />} />
                <Route path="/vr" element={<VR />} />
                <Route path="/360-view" element={<Panorama360 />} />
                <Route path="/sketch-pad" element={<SketchPad />} />
                <Route path="/visualization-vs-reality" element={<VisualizationVsReality />} />
                <Route path="/project/:slug" element={<ProjectDetail />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </Layout>
    );
}

export default App;
